export const spinnerData = [
  {
    "id": 1,
    "className": "spinner-1",
    "css": ".spinner-1  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 47px;\n  color: #3498DB;\n}\n\n.spinner-1 svg  {\n\n  animation: edu-flip 2.96s infinite linear;\n}\n\n.spinner-1  {\n\n  position: relative;\n  width: 67px;\n  height: 67px;\n}\n\n.spinner-1::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #3498DB;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-1\">\n  <FaReact />\n</div>"
  },
  {
    "id": 2,
    "className": "spinner-2",
    "css": ".spinner-2  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #FF5733;\n}\n\n.spinner-2 svg  {\n\n  animation: edu-bounce 1.74s infinite linear;\n}\n\n.spinner-2  {\n\n  border-bottom: 3px solid #FF5733;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-2\">\n  <FaReact />\n</div>"
  },
  {
    "id": 3,
    "className": "spinner-3",
    "css": ".spinner-3  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 44px;\n  color: #FF8C33;\n}\n\n.spinner-3 svg  {\n\n  animation: edu-fade 2.16s infinite linear;\n}",
    "html": "<div className=\"spinner-3\">\n  <FaReact />\n</div>"
  },
  {
    "id": 4,
    "className": "spinner-4",
    "css": ".spinner-4  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #33FF8C;\n}\n\n.spinner-4 svg  {\n\n  animation: edu-fade 1.76s infinite linear;\n}",
    "html": "<div className=\"spinner-4\">\n  <FaReact />\n</div>"
  },
  {
    "id": 5,
    "className": "spinner-5",
    "css": ".spinner-5  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #E74C3C;\n}\n\n.spinner-5 svg  {\n\n  animation: edu-spin-reverse 1.09s infinite linear;\n}\n\n.spinner-5  {\n\n  width: 68px;\n  height: 68px;\n  border: 2px solid #E74C3C;\n  border-radius: 50%;\n  background-color: #E74C3C10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-5\">\n  <FaReact />\n</div>"
  },
  {
    "id": 6,
    "className": "spinner-6",
    "css": ".spinner-6  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #8E44AD;\n}\n\n.spinner-6 svg  {\n\n  animation: edu-fade 2.36s infinite linear;\n}\n\n.spinner-6  {\n\n  position: relative;\n  width: 65px;\n  height: 65px;\n}\n\n.spinner-6::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #8E44AD;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-6\">\n  <FaReact />\n</div>"
  },
  {
    "id": 7,
    "className": "spinner-7",
    "css": ".spinner-7  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #FF33A1;\n}\n\n.spinner-7 svg  {\n\n  animation: edu-spin 2.12s infinite linear;\n}\n\n.spinner-7  {\n\n  border-bottom: 3px solid #FF33A1;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-7\">\n  <FaReact />\n</div>"
  },
  {
    "id": 8,
    "className": "spinner-8",
    "css": ".spinner-8  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #FF33A1;\n}\n\n.spinner-8 svg  {\n\n  animation: edu-wiggle 1.85s infinite linear;\n}",
    "html": "<div className=\"spinner-8\">\n  <FaReact />\n</div>"
  },
  {
    "id": 9,
    "className": "spinner-9",
    "css": ".spinner-9  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #E74C3C;\n}\n\n.spinner-9 svg  {\n\n  animation: edu-spin 1.98s infinite linear;\n}",
    "html": "<div className=\"spinner-9\">\n  <FaReact />\n</div>"
  },
  {
    "id": 10,
    "className": "spinner-10",
    "css": ".spinner-10  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #ECF0F1;\n}\n\n.spinner-10 svg  {\n\n  animation: edu-pulse 2.95s infinite linear;\n}\n\n.spinner-10  {\n\n  width: 65px;\n  height: 65px;\n  border: 2px solid #ECF0F1;\n  border-radius: 50%;\n  background-color: #ECF0F110;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-10\">\n  <FaReact />\n</div>"
  },
  {
    "id": 11,
    "className": "spinner-11",
    "css": ".spinner-11  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 40px;\n  color: #8C33FF;\n}\n\n.spinner-11 svg  {\n\n  animation: edu-flip 1.02s infinite linear;\n}\n\n.spinner-11  {\n\n  position: relative;\n  width: 60px;\n  height: 60px;\n}\n\n.spinner-11::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #8C33FF;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-11\">\n  <FaReact />\n</div>"
  },
  {
    "id": 12,
    "className": "spinner-12",
    "css": ".spinner-12  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #3498DB;\n}\n\n.spinner-12 svg  {\n\n  animation: edu-fade 1.7s infinite linear;\n}\n\n.spinner-12  {\n\n  border-bottom: 3px solid #3498DB;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-12\">\n  <FaReact />\n</div>"
  },
  {
    "id": 13,
    "className": "spinner-13",
    "css": ".spinner-13  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 31px;\n  color: #A133FF;\n}\n\n.spinner-13 svg  {\n\n  animation: edu-bounce 1.03s infinite linear;\n}",
    "html": "<div className=\"spinner-13\">\n  <FaReact />\n</div>"
  },
  {
    "id": 14,
    "className": "spinner-14",
    "css": ".spinner-14  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #FF8C33;\n}\n\n.spinner-14 svg  {\n\n  animation: edu-bounce 2.45s infinite linear;\n}",
    "html": "<div className=\"spinner-14\">\n  <FaReact />\n</div>"
  },
  {
    "id": 15,
    "className": "spinner-15",
    "css": ".spinner-15  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 34px;\n  color: #3357FF;\n}\n\n.spinner-15 svg  {\n\n  animation: edu-fade 2.23s infinite linear;\n}\n\n.spinner-15  {\n\n  width: 54px;\n  height: 54px;\n  border: 2px solid #3357FF;\n  border-radius: 50%;\n  background-color: #3357FF10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-15\">\n  <FaReact />\n</div>"
  },
  {
    "id": 16,
    "className": "spinner-16",
    "css": ".spinner-16  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 34px;\n  color: #8E44AD;\n}\n\n.spinner-16 svg  {\n\n  animation: edu-pulse 2.01s infinite linear;\n}\n\n.spinner-16  {\n\n  position: relative;\n  width: 54px;\n  height: 54px;\n}\n\n.spinner-16::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #8E44AD;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-16\">\n  <FaReact />\n</div>"
  },
  {
    "id": 17,
    "className": "spinner-17",
    "css": ".spinner-17  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #3357FF;\n}\n\n.spinner-17 svg  {\n\n  animation: edu-wiggle 1.75s infinite linear;\n}\n\n.spinner-17  {\n\n  border-bottom: 3px solid #3357FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-17\">\n  <FaReact />\n</div>"
  },
  {
    "id": 18,
    "className": "spinner-18",
    "css": ".spinner-18  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 47px;\n  color: #2C3E50;\n}\n\n.spinner-18 svg  {\n\n  animation: edu-bounce 1.1s infinite linear;\n}",
    "html": "<div className=\"spinner-18\">\n  <FaReact />\n</div>"
  },
  {
    "id": 19,
    "className": "spinner-19",
    "css": ".spinner-19  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #A133FF;\n}\n\n.spinner-19 svg  {\n\n  animation: edu-pulse 1.55s infinite linear;\n}",
    "html": "<div className=\"spinner-19\">\n  <FaReact />\n</div>"
  },
  {
    "id": 20,
    "className": "spinner-20",
    "css": ".spinner-20  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 35px;\n  color: #33FFF5;\n}\n\n.spinner-20 svg  {\n\n  animation: edu-fade 1.43s infinite linear;\n}\n\n.spinner-20  {\n\n  width: 55px;\n  height: 55px;\n  border: 2px solid #33FFF5;\n  border-radius: 50%;\n  background-color: #33FFF510;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-20\">\n  <FaReact />\n</div>"
  },
  {
    "id": 21,
    "className": "spinner-21",
    "css": ".spinner-21  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  color: #8C33FF;\n}\n\n.spinner-21 svg  {\n\n  animation: edu-spin 2.53s infinite linear;\n}\n\n.spinner-21  {\n\n  position: relative;\n  width: 50px;\n  height: 50px;\n}\n\n.spinner-21::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #8C33FF;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-21\">\n  <FaReact />\n</div>"
  },
  {
    "id": 22,
    "className": "spinner-22",
    "css": ".spinner-22  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  color: #2C3E50;\n}\n\n.spinner-22 svg  {\n\n  animation: edu-wiggle 2.34s infinite linear;\n}\n\n.spinner-22  {\n\n  border-bottom: 3px solid #2C3E50;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-22\">\n  <FaReact />\n</div>"
  },
  {
    "id": 23,
    "className": "spinner-23",
    "css": ".spinner-23  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #ECF0F1;\n}\n\n.spinner-23 svg  {\n\n  animation: edu-bounce 1.01s infinite linear;\n}",
    "html": "<div className=\"spinner-23\">\n  <FaReact />\n</div>"
  },
  {
    "id": 24,
    "className": "spinner-24",
    "css": ".spinner-24  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #33FFF5;\n}\n\n.spinner-24 svg  {\n\n  animation: edu-flip 1.81s infinite linear;\n}",
    "html": "<div className=\"spinner-24\">\n  <FaReact />\n</div>"
  },
  {
    "id": 25,
    "className": "spinner-25",
    "css": ".spinner-25  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 40px;\n  color: #2C3E50;\n}\n\n.spinner-25 svg  {\n\n  animation: edu-spin-reverse 2.37s infinite linear;\n}\n\n.spinner-25  {\n\n  width: 60px;\n  height: 60px;\n  border: 2px solid #2C3E50;\n  border-radius: 50%;\n  background-color: #2C3E5010;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-25\">\n  <FaReact />\n</div>"
  },
  {
    "id": 26,
    "className": "spinner-26",
    "css": ".spinner-26  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 34px;\n  color: #3357FF;\n}\n\n.spinner-26 svg  {\n\n  animation: edu-pulse 2.17s infinite linear;\n}\n\n.spinner-26  {\n\n  position: relative;\n  width: 54px;\n  height: 54px;\n}\n\n.spinner-26::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #3357FF;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-26\">\n  <FaReact />\n</div>"
  },
  {
    "id": 27,
    "className": "spinner-27",
    "css": ".spinner-27  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 50px;\n  color: #33FF57;\n}\n\n.spinner-27 svg  {\n\n  animation: edu-bounce 1.62s infinite linear;\n}\n\n.spinner-27  {\n\n  border-bottom: 3px solid #33FF57;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-27\">\n  <FaReact />\n</div>"
  },
  {
    "id": 28,
    "className": "spinner-28",
    "css": ".spinner-28  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #3357FF;\n}\n\n.spinner-28 svg  {\n\n  animation: edu-pulse 1.58s infinite linear;\n}",
    "html": "<div className=\"spinner-28\">\n  <FaReact />\n</div>"
  },
  {
    "id": 29,
    "className": "spinner-29",
    "css": ".spinner-29  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #33FF57;\n}\n\n.spinner-29 svg  {\n\n  animation: edu-pulse 1.68s infinite linear;\n}",
    "html": "<div className=\"spinner-29\">\n  <FaReact />\n</div>"
  },
  {
    "id": 30,
    "className": "spinner-30",
    "css": ".spinner-30  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #D35400;\n}\n\n.spinner-30 svg  {\n\n  animation: edu-spin-reverse 1.62s infinite linear;\n}\n\n.spinner-30  {\n\n  width: 53px;\n  height: 53px;\n  border: 2px solid #D35400;\n  border-radius: 50%;\n  background-color: #D3540010;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-30\">\n  <FaReact />\n</div>"
  },
  {
    "id": 31,
    "className": "spinner-31",
    "css": ".spinner-31  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #2C3E50;\n}\n\n.spinner-31 svg  {\n\n  animation: edu-pulse 2.42s infinite linear;\n}\n\n.spinner-31  {\n\n  position: relative;\n  width: 68px;\n  height: 68px;\n}\n\n.spinner-31::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #2C3E50;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-31\">\n  <FaReact />\n</div>"
  },
  {
    "id": 32,
    "className": "spinner-32",
    "css": ".spinner-32  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #A133FF;\n}\n\n.spinner-32 svg  {\n\n  animation: edu-pulse 1.46s infinite linear;\n}\n\n.spinner-32  {\n\n  border-bottom: 3px solid #A133FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-32\">\n  <FaReact />\n</div>"
  },
  {
    "id": 33,
    "className": "spinner-33",
    "css": ".spinner-33  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 40px;\n  color: #FF8C33;\n}\n\n.spinner-33 svg  {\n\n  animation: edu-spin-reverse 1.81s infinite linear;\n}",
    "html": "<div className=\"spinner-33\">\n  <FaReact />\n</div>"
  },
  {
    "id": 34,
    "className": "spinner-34",
    "css": ".spinner-34  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #2C3E50;\n}\n\n.spinner-34 svg  {\n\n  animation: edu-spin-reverse 2.61s infinite linear;\n}",
    "html": "<div className=\"spinner-34\">\n  <FaReact />\n</div>"
  },
  {
    "id": 35,
    "className": "spinner-35",
    "css": ".spinner-35  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 44px;\n  color: #33FFF5;\n}\n\n.spinner-35 svg  {\n\n  animation: edu-pulse 1.98s infinite linear;\n}\n\n.spinner-35  {\n\n  width: 64px;\n  height: 64px;\n  border: 2px solid #33FFF5;\n  border-radius: 50%;\n  background-color: #33FFF510;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-35\">\n  <FaReact />\n</div>"
  },
  {
    "id": 36,
    "className": "spinner-36",
    "css": ".spinner-36  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 38px;\n  color: #33FF57;\n}\n\n.spinner-36 svg  {\n\n  animation: edu-wiggle 1.38s infinite linear;\n}\n\n.spinner-36  {\n\n  position: relative;\n  width: 58px;\n  height: 58px;\n}\n\n.spinner-36::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #33FF57;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-36\">\n  <FaReact />\n</div>"
  },
  {
    "id": 37,
    "className": "spinner-37",
    "css": ".spinner-37  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 36px;\n  color: #A133FF;\n}\n\n.spinner-37 svg  {\n\n  animation: edu-fade 1.47s infinite linear;\n}\n\n.spinner-37  {\n\n  border-bottom: 3px solid #A133FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-37\">\n  <FaReact />\n</div>"
  },
  {
    "id": 38,
    "className": "spinner-38",
    "css": ".spinner-38  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  color: #8E44AD;\n}\n\n.spinner-38 svg  {\n\n  animation: edu-spin 1.59s infinite linear;\n}",
    "html": "<div className=\"spinner-38\">\n  <FaReact />\n</div>"
  },
  {
    "id": 39,
    "className": "spinner-39",
    "css": ".spinner-39  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 41px;\n  color: #A133FF;\n}\n\n.spinner-39 svg  {\n\n  animation: edu-spin 1.82s infinite linear;\n}",
    "html": "<div className=\"spinner-39\">\n  <FaReact />\n</div>"
  },
  {
    "id": 40,
    "className": "spinner-40",
    "css": ".spinner-40  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #27AE60;\n}\n\n.spinner-40 svg  {\n\n  animation: edu-wiggle 2.7s infinite linear;\n}\n\n.spinner-40  {\n\n  width: 63px;\n  height: 63px;\n  border: 2px solid #27AE60;\n  border-radius: 50%;\n  background-color: #27AE6010;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-40\">\n  <FaReact />\n</div>"
  },
  {
    "id": 41,
    "className": "spinner-41",
    "css": ".spinner-41  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #8C33FF;\n}\n\n.spinner-41 svg  {\n\n  animation: edu-flip 1.17s infinite linear;\n}\n\n.spinner-41  {\n\n  position: relative;\n  width: 53px;\n  height: 53px;\n}\n\n.spinner-41::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #8C33FF;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-41\">\n  <FaReact />\n</div>"
  },
  {
    "id": 42,
    "className": "spinner-42",
    "css": ".spinner-42  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 31px;\n  color: #33FF8C;\n}\n\n.spinner-42 svg  {\n\n  animation: edu-wiggle 1.76s infinite linear;\n}\n\n.spinner-42  {\n\n  border-bottom: 3px solid #33FF8C;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-42\">\n  <FaReact />\n</div>"
  },
  {
    "id": 43,
    "className": "spinner-43",
    "css": ".spinner-43  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #E74C3C;\n}\n\n.spinner-43 svg  {\n\n  animation: edu-bounce 1.7s infinite linear;\n}",
    "html": "<div className=\"spinner-43\">\n  <FaReact />\n</div>"
  },
  {
    "id": 44,
    "className": "spinner-44",
    "css": ".spinner-44  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 41px;\n  color: #8C33FF;\n}\n\n.spinner-44 svg  {\n\n  animation: edu-spin 2.84s infinite linear;\n}",
    "html": "<div className=\"spinner-44\">\n  <FaReact />\n</div>"
  },
  {
    "id": 45,
    "className": "spinner-45",
    "css": ".spinner-45  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #3498DB;\n}\n\n.spinner-45 svg  {\n\n  animation: edu-fade 2.84s infinite linear;\n}\n\n.spinner-45  {\n\n  width: 59px;\n  height: 59px;\n  border: 2px solid #3498DB;\n  border-radius: 50%;\n  background-color: #3498DB10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-45\">\n  <FaReact />\n</div>"
  },
  {
    "id": 46,
    "className": "spinner-46",
    "css": ".spinner-46  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 36px;\n  color: #FF33A1;\n}\n\n.spinner-46 svg  {\n\n  animation: edu-bounce 2.57s infinite linear;\n}\n\n.spinner-46  {\n\n  position: relative;\n  width: 56px;\n  height: 56px;\n}\n\n.spinner-46::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #FF33A1;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-46\">\n  <FaReact />\n</div>"
  },
  {
    "id": 47,
    "className": "spinner-47",
    "css": ".spinner-47  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  color: #8E44AD;\n}\n\n.spinner-47 svg  {\n\n  animation: edu-spin 2.69s infinite linear;\n}\n\n.spinner-47  {\n\n  border-bottom: 3px solid #8E44AD;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-47\">\n  <FaReact />\n</div>"
  },
  {
    "id": 48,
    "className": "spinner-48",
    "css": ".spinner-48  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #27AE60;\n}\n\n.spinner-48 svg  {\n\n  animation: edu-fade 2.81s infinite linear;\n}",
    "html": "<div className=\"spinner-48\">\n  <FaReact />\n</div>"
  },
  {
    "id": 49,
    "className": "spinner-49",
    "css": ".spinner-49  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 34px;\n  color: #FF33A1;\n}\n\n.spinner-49 svg  {\n\n  animation: edu-bounce 2.66s infinite linear;\n}",
    "html": "<div className=\"spinner-49\">\n  <FaReact />\n</div>"
  },
  {
    "id": 50,
    "className": "spinner-50",
    "css": ".spinner-50  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 37px;\n  color: #E74C3C;\n}\n\n.spinner-50 svg  {\n\n  animation: edu-flip 2.26s infinite linear;\n}\n\n.spinner-50  {\n\n  width: 57px;\n  height: 57px;\n  border: 2px solid #E74C3C;\n  border-radius: 50%;\n  background-color: #E74C3C10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-50\">\n  <FaReact />\n</div>"
  },
  {
    "id": 51,
    "className": "spinner-51",
    "css": ".spinner-51  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 38px;\n  color: #3498DB;\n}\n\n.spinner-51 svg  {\n\n  animation: edu-bounce 2.83s infinite linear;\n}\n\n.spinner-51  {\n\n  position: relative;\n  width: 58px;\n  height: 58px;\n}\n\n.spinner-51::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #3498DB;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-51\">\n  <FaReact />\n</div>"
  },
  {
    "id": 52,
    "className": "spinner-52",
    "css": ".spinner-52  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  color: #33FF57;\n}\n\n.spinner-52 svg  {\n\n  animation: edu-fade 1.15s infinite linear;\n}\n\n.spinner-52  {\n\n  border-bottom: 3px solid #33FF57;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-52\">\n  <FaReact />\n</div>"
  },
  {
    "id": 53,
    "className": "spinner-53",
    "css": ".spinner-53  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  color: #FF5733;\n}\n\n.spinner-53 svg  {\n\n  animation: edu-spin-reverse 2.89s infinite linear;\n}",
    "html": "<div className=\"spinner-53\">\n  <FaReact />\n</div>"
  },
  {
    "id": 54,
    "className": "spinner-54",
    "css": ".spinner-54  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #F5FF33;\n}\n\n.spinner-54 svg  {\n\n  animation: edu-bounce 1.97s infinite linear;\n}",
    "html": "<div className=\"spinner-54\">\n  <FaReact />\n</div>"
  },
  {
    "id": 55,
    "className": "spinner-55",
    "css": ".spinner-55  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #2980B9;\n}\n\n.spinner-55 svg  {\n\n  animation: edu-fade 2.95s infinite linear;\n}\n\n.spinner-55  {\n\n  width: 69px;\n  height: 69px;\n  border: 2px solid #2980B9;\n  border-radius: 50%;\n  background-color: #2980B910;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-55\">\n  <FaReact />\n</div>"
  },
  {
    "id": 56,
    "className": "spinner-56",
    "css": ".spinner-56  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  color: #2C3E50;\n}\n\n.spinner-56 svg  {\n\n  animation: edu-fade 2.05s infinite linear;\n}\n\n.spinner-56  {\n\n  position: relative;\n  width: 66px;\n  height: 66px;\n}\n\n.spinner-56::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #2C3E50;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-56\">\n  <FaReact />\n</div>"
  },
  {
    "id": 57,
    "className": "spinner-57",
    "css": ".spinner-57  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 38px;\n  color: #FF8C33;\n}\n\n.spinner-57 svg  {\n\n  animation: edu-wiggle 1.96s infinite linear;\n}\n\n.spinner-57  {\n\n  border-bottom: 3px solid #FF8C33;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-57\">\n  <FaReact />\n</div>"
  },
  {
    "id": 58,
    "className": "spinner-58",
    "css": ".spinner-58  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  color: #27AE60;\n}\n\n.spinner-58 svg  {\n\n  animation: edu-fade 1.44s infinite linear;\n}",
    "html": "<div className=\"spinner-58\">\n  <FaReact />\n</div>"
  },
  {
    "id": 59,
    "className": "spinner-59",
    "css": ".spinner-59  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #8E44AD;\n}\n\n.spinner-59 svg  {\n\n  animation: edu-bounce 1.62s infinite linear;\n}",
    "html": "<div className=\"spinner-59\">\n  <FaReact />\n</div>"
  },
  {
    "id": 60,
    "className": "spinner-60",
    "css": ".spinner-60  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #FF5733;\n}\n\n.spinner-60 svg  {\n\n  animation: edu-fade 2.37s infinite linear;\n}\n\n.spinner-60  {\n\n  width: 63px;\n  height: 63px;\n  border: 2px solid #FF5733;\n  border-radius: 50%;\n  background-color: #FF573310;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-60\">\n  <FaReact />\n</div>"
  },
  {
    "id": 61,
    "className": "spinner-61",
    "css": ".spinner-61  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #2C3E50;\n}\n\n.spinner-61 svg  {\n\n  animation: edu-flip 2.71s infinite linear;\n}\n\n.spinner-61  {\n\n  position: relative;\n  width: 63px;\n  height: 63px;\n}\n\n.spinner-61::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #2C3E50;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-61\">\n  <FaReact />\n</div>"
  },
  {
    "id": 62,
    "className": "spinner-62",
    "css": ".spinner-62  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 37px;\n  color: #A133FF;\n}\n\n.spinner-62 svg  {\n\n  animation: edu-bounce 2.08s infinite linear;\n}\n\n.spinner-62  {\n\n  border-bottom: 3px solid #A133FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-62\">\n  <FaReact />\n</div>"
  },
  {
    "id": 63,
    "className": "spinner-63",
    "css": ".spinner-63  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 34px;\n  color: #F1C40F;\n}\n\n.spinner-63 svg  {\n\n  animation: edu-spin-reverse 2.54s infinite linear;\n}",
    "html": "<div className=\"spinner-63\">\n  <FaReact />\n</div>"
  },
  {
    "id": 64,
    "className": "spinner-64",
    "css": ".spinner-64  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #FF5733;\n}\n\n.spinner-64 svg  {\n\n  animation: edu-pulse 1.34s infinite linear;\n}",
    "html": "<div className=\"spinner-64\">\n  <FaReact />\n</div>"
  },
  {
    "id": 65,
    "className": "spinner-65",
    "css": ".spinner-65  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 35px;\n  color: #D35400;\n}\n\n.spinner-65 svg  {\n\n  animation: edu-spin 1.8s infinite linear;\n}\n\n.spinner-65  {\n\n  width: 55px;\n  height: 55px;\n  border: 2px solid #D35400;\n  border-radius: 50%;\n  background-color: #D3540010;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-65\">\n  <FaReact />\n</div>"
  },
  {
    "id": 66,
    "className": "spinner-66",
    "css": ".spinner-66  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 31px;\n  color: #F1C40F;\n}\n\n.spinner-66 svg  {\n\n  animation: edu-spin 1.76s infinite linear;\n}\n\n.spinner-66  {\n\n  position: relative;\n  width: 51px;\n  height: 51px;\n}\n\n.spinner-66::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #F1C40F;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-66\">\n  <FaReact />\n</div>"
  },
  {
    "id": 67,
    "className": "spinner-67",
    "css": ".spinner-67  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 37px;\n  color: #33FF8C;\n}\n\n.spinner-67 svg  {\n\n  animation: edu-bounce 2.49s infinite linear;\n}\n\n.spinner-67  {\n\n  border-bottom: 3px solid #33FF8C;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-67\">\n  <FaReact />\n</div>"
  },
  {
    "id": 68,
    "className": "spinner-68",
    "css": ".spinner-68  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #16A085;\n}\n\n.spinner-68 svg  {\n\n  animation: edu-wiggle 1.56s infinite linear;\n}",
    "html": "<div className=\"spinner-68\">\n  <FaReact />\n</div>"
  },
  {
    "id": 69,
    "className": "spinner-69",
    "css": ".spinner-69  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #FF5733;\n}\n\n.spinner-69 svg  {\n\n  animation: edu-spin 2.54s infinite linear;\n}",
    "html": "<div className=\"spinner-69\">\n  <FaReact />\n</div>"
  },
  {
    "id": 70,
    "className": "spinner-70",
    "css": ".spinner-70  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 42px;\n  color: #F1C40F;\n}\n\n.spinner-70 svg  {\n\n  animation: edu-bounce 1.66s infinite linear;\n}\n\n.spinner-70  {\n\n  width: 62px;\n  height: 62px;\n  border: 2px solid #F1C40F;\n  border-radius: 50%;\n  background-color: #F1C40F10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-70\">\n  <FaReact />\n</div>"
  },
  {
    "id": 71,
    "className": "spinner-71",
    "css": ".spinner-71  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  color: #FF33A1;\n}\n\n.spinner-71 svg  {\n\n  animation: edu-pulse 2.36s infinite linear;\n}\n\n.spinner-71  {\n\n  position: relative;\n  width: 66px;\n  height: 66px;\n}\n\n.spinner-71::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #FF33A1;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-71\">\n  <FaReact />\n</div>"
  },
  {
    "id": 72,
    "className": "spinner-72",
    "css": ".spinner-72  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 41px;\n  color: #8C33FF;\n}\n\n.spinner-72 svg  {\n\n  animation: edu-pulse 2.84s infinite linear;\n}\n\n.spinner-72  {\n\n  border-bottom: 3px solid #8C33FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-72\">\n  <FaReact />\n</div>"
  },
  {
    "id": 73,
    "className": "spinner-73",
    "css": ".spinner-73  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 37px;\n  color: #33FF57;\n}\n\n.spinner-73 svg  {\n\n  animation: edu-spin 1.8s infinite linear;\n}",
    "html": "<div className=\"spinner-73\">\n  <FaReact />\n</div>"
  },
  {
    "id": 74,
    "className": "spinner-74",
    "css": ".spinner-74  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #2980B9;\n}\n\n.spinner-74 svg  {\n\n  animation: edu-spin-reverse 2.43s infinite linear;\n}",
    "html": "<div className=\"spinner-74\">\n  <FaReact />\n</div>"
  },
  {
    "id": 75,
    "className": "spinner-75",
    "css": ".spinner-75  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  color: #A133FF;\n}\n\n.spinner-75 svg  {\n\n  animation: edu-flip 2.32s infinite linear;\n}\n\n.spinner-75  {\n\n  width: 66px;\n  height: 66px;\n  border: 2px solid #A133FF;\n  border-radius: 50%;\n  background-color: #A133FF10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-75\">\n  <FaReact />\n</div>"
  },
  {
    "id": 76,
    "className": "spinner-76",
    "css": ".spinner-76  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 42px;\n  color: #3357FF;\n}\n\n.spinner-76 svg  {\n\n  animation: edu-wiggle 1.05s infinite linear;\n}\n\n.spinner-76  {\n\n  position: relative;\n  width: 62px;\n  height: 62px;\n}\n\n.spinner-76::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #3357FF;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-76\">\n  <FaReact />\n</div>"
  },
  {
    "id": 77,
    "className": "spinner-77",
    "css": ".spinner-77  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #3498DB;\n}\n\n.spinner-77 svg  {\n\n  animation: edu-pulse 2.95s infinite linear;\n}\n\n.spinner-77  {\n\n  border-bottom: 3px solid #3498DB;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-77\">\n  <FaReact />\n</div>"
  },
  {
    "id": 78,
    "className": "spinner-78",
    "css": ".spinner-78  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #A133FF;\n}\n\n.spinner-78 svg  {\n\n  animation: edu-fade 1.23s infinite linear;\n}",
    "html": "<div className=\"spinner-78\">\n  <FaReact />\n</div>"
  },
  {
    "id": 79,
    "className": "spinner-79",
    "css": ".spinner-79  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #16A085;\n}\n\n.spinner-79 svg  {\n\n  animation: edu-pulse 1.63s infinite linear;\n}",
    "html": "<div className=\"spinner-79\">\n  <FaReact />\n</div>"
  },
  {
    "id": 80,
    "className": "spinner-80",
    "css": ".spinner-80  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #A133FF;\n}\n\n.spinner-80 svg  {\n\n  animation: edu-fade 1.02s infinite linear;\n}\n\n.spinner-80  {\n\n  width: 59px;\n  height: 59px;\n  border: 2px solid #A133FF;\n  border-radius: 50%;\n  background-color: #A133FF10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-80\">\n  <FaReact />\n</div>"
  },
  {
    "id": 81,
    "className": "spinner-81",
    "css": ".spinner-81  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 36px;\n  color: #3498DB;\n}\n\n.spinner-81 svg  {\n\n  animation: edu-pulse 2.95s infinite linear;\n}\n\n.spinner-81  {\n\n  position: relative;\n  width: 56px;\n  height: 56px;\n}\n\n.spinner-81::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #3498DB;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-81\">\n  <FaReact />\n</div>"
  },
  {
    "id": 82,
    "className": "spinner-82",
    "css": ".spinner-82  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #D35400;\n}\n\n.spinner-82 svg  {\n\n  animation: edu-spin 1.06s infinite linear;\n}\n\n.spinner-82  {\n\n  border-bottom: 3px solid #D35400;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-82\">\n  <FaReact />\n</div>"
  },
  {
    "id": 83,
    "className": "spinner-83",
    "css": ".spinner-83  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 44px;\n  color: #FF8C33;\n}\n\n.spinner-83 svg  {\n\n  animation: edu-spin 1.16s infinite linear;\n}",
    "html": "<div className=\"spinner-83\">\n  <FaReact />\n</div>"
  },
  {
    "id": 84,
    "className": "spinner-84",
    "css": ".spinner-84  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 40px;\n  color: #FF33A1;\n}\n\n.spinner-84 svg  {\n\n  animation: edu-wiggle 2.7s infinite linear;\n}",
    "html": "<div className=\"spinner-84\">\n  <FaReact />\n</div>"
  },
  {
    "id": 85,
    "className": "spinner-85",
    "css": ".spinner-85  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 50px;\n  color: #33FFF5;\n}\n\n.spinner-85 svg  {\n\n  animation: edu-bounce 1.69s infinite linear;\n}\n\n.spinner-85  {\n\n  width: 70px;\n  height: 70px;\n  border: 2px solid #33FFF5;\n  border-radius: 50%;\n  background-color: #33FFF510;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-85\">\n  <FaReact />\n</div>"
  },
  {
    "id": 86,
    "className": "spinner-86",
    "css": ".spinner-86  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #2C3E50;\n}\n\n.spinner-86 svg  {\n\n  animation: edu-spin-reverse 1.76s infinite linear;\n}\n\n.spinner-86  {\n\n  position: relative;\n  width: 69px;\n  height: 69px;\n}\n\n.spinner-86::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #2C3E50;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-86\">\n  <FaReact />\n</div>"
  },
  {
    "id": 87,
    "className": "spinner-87",
    "css": ".spinner-87  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 41px;\n  color: #E74C3C;\n}\n\n.spinner-87 svg  {\n\n  animation: edu-pulse 2.84s infinite linear;\n}\n\n.spinner-87  {\n\n  border-bottom: 3px solid #E74C3C;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-87\">\n  <FaReact />\n</div>"
  },
  {
    "id": 88,
    "className": "spinner-88",
    "css": ".spinner-88  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 36px;\n  color: #FF33A1;\n}\n\n.spinner-88 svg  {\n\n  animation: edu-wiggle 2.01s infinite linear;\n}",
    "html": "<div className=\"spinner-88\">\n  <FaReact />\n</div>"
  },
  {
    "id": 89,
    "className": "spinner-89",
    "css": ".spinner-89  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  color: #33FFF5;\n}\n\n.spinner-89 svg  {\n\n  animation: edu-wiggle 1.57s infinite linear;\n}",
    "html": "<div className=\"spinner-89\">\n  <FaReact />\n</div>"
  },
  {
    "id": 90,
    "className": "spinner-90",
    "css": ".spinner-90  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 36px;\n  color: #16A085;\n}\n\n.spinner-90 svg  {\n\n  animation: edu-fade 1.15s infinite linear;\n}\n\n.spinner-90  {\n\n  width: 56px;\n  height: 56px;\n  border: 2px solid #16A085;\n  border-radius: 50%;\n  background-color: #16A08510;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-90\">\n  <FaReact />\n</div>"
  },
  {
    "id": 91,
    "className": "spinner-91",
    "css": ".spinner-91  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 37px;\n  color: #33FF57;\n}\n\n.spinner-91 svg  {\n\n  animation: edu-bounce 1.18s infinite linear;\n}\n\n.spinner-91  {\n\n  position: relative;\n  width: 57px;\n  height: 57px;\n}\n\n.spinner-91::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #33FF57;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-91\">\n  <FaReact />\n</div>"
  },
  {
    "id": 92,
    "className": "spinner-92",
    "css": ".spinner-92  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 38px;\n  color: #2980B9;\n}\n\n.spinner-92 svg  {\n\n  animation: edu-wiggle 2.04s infinite linear;\n}\n\n.spinner-92  {\n\n  border-bottom: 3px solid #2980B9;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-92\">\n  <FaReact />\n</div>"
  },
  {
    "id": 93,
    "className": "spinner-93",
    "css": ".spinner-93  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 34px;\n  color: #2980B9;\n}\n\n.spinner-93 svg  {\n\n  animation: edu-pulse 2.95s infinite linear;\n}",
    "html": "<div className=\"spinner-93\">\n  <FaReact />\n</div>"
  },
  {
    "id": 94,
    "className": "spinner-94",
    "css": ".spinner-94  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 47px;\n  color: #3498DB;\n}\n\n.spinner-94 svg  {\n\n  animation: edu-bounce 1.28s infinite linear;\n}",
    "html": "<div className=\"spinner-94\">\n  <FaReact />\n</div>"
  },
  {
    "id": 95,
    "className": "spinner-95",
    "css": ".spinner-95  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 35px;\n  color: #FF33A1;\n}\n\n.spinner-95 svg  {\n\n  animation: edu-flip 2.36s infinite linear;\n}\n\n.spinner-95  {\n\n  width: 55px;\n  height: 55px;\n  border: 2px solid #FF33A1;\n  border-radius: 50%;\n  background-color: #FF33A110;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-95\">\n  <FaReact />\n</div>"
  },
  {
    "id": 96,
    "className": "spinner-96",
    "css": ".spinner-96  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 34px;\n  color: #FF5733;\n}\n\n.spinner-96 svg  {\n\n  animation: edu-spin-reverse 1.61s infinite linear;\n}\n\n.spinner-96  {\n\n  position: relative;\n  width: 54px;\n  height: 54px;\n}\n\n.spinner-96::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #FF5733;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-96\">\n  <FaReact />\n</div>"
  },
  {
    "id": 97,
    "className": "spinner-97",
    "css": ".spinner-97  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 35px;\n  color: #F1C40F;\n}\n\n.spinner-97 svg  {\n\n  animation: edu-bounce 2.66s infinite linear;\n}\n\n.spinner-97  {\n\n  border-bottom: 3px solid #F1C40F;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-97\">\n  <FaReact />\n</div>"
  },
  {
    "id": 98,
    "className": "spinner-98",
    "css": ".spinner-98  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 34px;\n  color: #2980B9;\n}\n\n.spinner-98 svg  {\n\n  animation: edu-bounce 1.24s infinite linear;\n}",
    "html": "<div className=\"spinner-98\">\n  <FaReact />\n</div>"
  },
  {
    "id": 99,
    "className": "spinner-99",
    "css": ".spinner-99  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 50px;\n  color: #8C33FF;\n}\n\n.spinner-99 svg  {\n\n  animation: edu-fade 1.7s infinite linear;\n}",
    "html": "<div className=\"spinner-99\">\n  <FaReact />\n</div>"
  },
  {
    "id": 100,
    "className": "spinner-100",
    "css": ".spinner-100  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #FF5733;\n}\n\n.spinner-100 svg  {\n\n  animation: edu-flip 2.07s infinite linear;\n}\n\n.spinner-100  {\n\n  width: 68px;\n  height: 68px;\n  border: 2px solid #FF5733;\n  border-radius: 50%;\n  background-color: #FF573310;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-100\">\n  <FaReact />\n</div>"
  },
  {
    "id": 101,
    "className": "spinner-101",
    "css": ".spinner-101  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #33FF8C;\n}\n\n.spinner-101 svg  {\n\n  animation: edu-bounce 1.11s infinite linear;\n}\n\n.spinner-101  {\n\n  position: relative;\n  width: 59px;\n  height: 59px;\n}\n\n.spinner-101::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #33FF8C;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-101\">\n  <FaReact />\n</div>"
  },
  {
    "id": 102,
    "className": "spinner-102",
    "css": ".spinner-102  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #A133FF;\n}\n\n.spinner-102 svg  {\n\n  animation: edu-spin 2.61s infinite linear;\n}\n\n.spinner-102  {\n\n  border-bottom: 3px solid #A133FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-102\">\n  <FaReact />\n</div>"
  },
  {
    "id": 103,
    "className": "spinner-103",
    "css": ".spinner-103  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #3498DB;\n}\n\n.spinner-103 svg  {\n\n  animation: edu-pulse 1.29s infinite linear;\n}",
    "html": "<div className=\"spinner-103\">\n  <FaReact />\n</div>"
  },
  {
    "id": 104,
    "className": "spinner-104",
    "css": ".spinner-104  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #D35400;\n}\n\n.spinner-104 svg  {\n\n  animation: edu-wiggle 1.27s infinite linear;\n}",
    "html": "<div className=\"spinner-104\">\n  <FaReact />\n</div>"
  },
  {
    "id": 105,
    "className": "spinner-105",
    "css": ".spinner-105  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #FF5733;\n}\n\n.spinner-105 svg  {\n\n  animation: edu-fade 2.19s infinite linear;\n}\n\n.spinner-105  {\n\n  width: 52px;\n  height: 52px;\n  border: 2px solid #FF5733;\n  border-radius: 50%;\n  background-color: #FF573310;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-105\">\n  <FaReact />\n</div>"
  },
  {
    "id": 106,
    "className": "spinner-106",
    "css": ".spinner-106  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 47px;\n  color: #16A085;\n}\n\n.spinner-106 svg  {\n\n  animation: edu-spin 1.83s infinite linear;\n}\n\n.spinner-106  {\n\n  position: relative;\n  width: 67px;\n  height: 67px;\n}\n\n.spinner-106::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #16A085;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-106\">\n  <FaReact />\n</div>"
  },
  {
    "id": 107,
    "className": "spinner-107",
    "css": ".spinner-107  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #33FFF5;\n}\n\n.spinner-107 svg  {\n\n  animation: edu-pulse 2.95s infinite linear;\n}\n\n.spinner-107  {\n\n  border-bottom: 3px solid #33FFF5;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-107\">\n  <FaReact />\n</div>"
  },
  {
    "id": 108,
    "className": "spinner-108",
    "css": ".spinner-108  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 36px;\n  color: #27AE60;\n}\n\n.spinner-108 svg  {\n\n  animation: edu-bounce 1.24s infinite linear;\n}",
    "html": "<div className=\"spinner-108\">\n  <FaReact />\n</div>"
  },
  {
    "id": 109,
    "className": "spinner-109",
    "css": ".spinner-109  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #FF5733;\n}\n\n.spinner-109 svg  {\n\n  animation: edu-pulse 2.75s infinite linear;\n}",
    "html": "<div className=\"spinner-109\">\n  <FaReact />\n</div>"
  },
  {
    "id": 110,
    "className": "spinner-110",
    "css": ".spinner-110  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 50px;\n  color: #33FFF5;\n}\n\n.spinner-110 svg  {\n\n  animation: edu-spin 2.46s infinite linear;\n}\n\n.spinner-110  {\n\n  width: 70px;\n  height: 70px;\n  border: 2px solid #33FFF5;\n  border-radius: 50%;\n  background-color: #33FFF510;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-110\">\n  <FaReact />\n</div>"
  },
  {
    "id": 111,
    "className": "spinner-111",
    "css": ".spinner-111  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 41px;\n  color: #2980B9;\n}\n\n.spinner-111 svg  {\n\n  animation: edu-flip 1.65s infinite linear;\n}\n\n.spinner-111  {\n\n  position: relative;\n  width: 61px;\n  height: 61px;\n}\n\n.spinner-111::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #2980B9;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-111\">\n  <FaReact />\n</div>"
  },
  {
    "id": 112,
    "className": "spinner-112",
    "css": ".spinner-112  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #D35400;\n}\n\n.spinner-112 svg  {\n\n  animation: edu-wiggle 1.21s infinite linear;\n}\n\n.spinner-112  {\n\n  border-bottom: 3px solid #D35400;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-112\">\n  <FaReact />\n</div>"
  },
  {
    "id": 113,
    "className": "spinner-113",
    "css": ".spinner-113  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 50px;\n  color: #D35400;\n}\n\n.spinner-113 svg  {\n\n  animation: edu-spin-reverse 1.11s infinite linear;\n}",
    "html": "<div className=\"spinner-113\">\n  <FaReact />\n</div>"
  },
  {
    "id": 114,
    "className": "spinner-114",
    "css": ".spinner-114  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #D35400;\n}\n\n.spinner-114 svg  {\n\n  animation: edu-fade 1.76s infinite linear;\n}",
    "html": "<div className=\"spinner-114\">\n  <FaReact />\n</div>"
  },
  {
    "id": 115,
    "className": "spinner-115",
    "css": ".spinner-115  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #ECF0F1;\n}\n\n.spinner-115 svg  {\n\n  animation: edu-fade 2.35s infinite linear;\n}\n\n.spinner-115  {\n\n  width: 53px;\n  height: 53px;\n  border: 2px solid #ECF0F1;\n  border-radius: 50%;\n  background-color: #ECF0F110;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-115\">\n  <FaReact />\n</div>"
  },
  {
    "id": 116,
    "className": "spinner-116",
    "css": ".spinner-116  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #33FF57;\n}\n\n.spinner-116 svg  {\n\n  animation: edu-pulse 1.47s infinite linear;\n}\n\n.spinner-116  {\n\n  position: relative;\n  width: 68px;\n  height: 68px;\n}\n\n.spinner-116::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #33FF57;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-116\">\n  <FaReact />\n</div>"
  },
  {
    "id": 117,
    "className": "spinner-117",
    "css": ".spinner-117  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #8E44AD;\n}\n\n.spinner-117 svg  {\n\n  animation: edu-fade 1.83s infinite linear;\n}\n\n.spinner-117  {\n\n  border-bottom: 3px solid #8E44AD;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-117\">\n  <FaReact />\n</div>"
  },
  {
    "id": 118,
    "className": "spinner-118",
    "css": ".spinner-118  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #2C3E50;\n}\n\n.spinner-118 svg  {\n\n  animation: edu-fade 1.37s infinite linear;\n}",
    "html": "<div className=\"spinner-118\">\n  <FaReact />\n</div>"
  },
  {
    "id": 119,
    "className": "spinner-119",
    "css": ".spinner-119  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 31px;\n  color: #FF33A1;\n}\n\n.spinner-119 svg  {\n\n  animation: edu-spin 2.46s infinite linear;\n}",
    "html": "<div className=\"spinner-119\">\n  <FaReact />\n</div>"
  },
  {
    "id": 120,
    "className": "spinner-120",
    "css": ".spinner-120  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  color: #2980B9;\n}\n\n.spinner-120 svg  {\n\n  animation: edu-spin-reverse 1.36s infinite linear;\n}\n\n.spinner-120  {\n\n  width: 66px;\n  height: 66px;\n  border: 2px solid #2980B9;\n  border-radius: 50%;\n  background-color: #2980B910;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-120\">\n  <FaReact />\n</div>"
  },
  {
    "id": 121,
    "className": "spinner-121",
    "css": ".spinner-121  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 35px;\n  color: #8E44AD;\n}\n\n.spinner-121 svg  {\n\n  animation: edu-bounce 2.74s infinite linear;\n}\n\n.spinner-121  {\n\n  position: relative;\n  width: 55px;\n  height: 55px;\n}\n\n.spinner-121::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #8E44AD;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-121\">\n  <FaReact />\n</div>"
  },
  {
    "id": 122,
    "className": "spinner-122",
    "css": ".spinner-122  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #F1C40F;\n}\n\n.spinner-122 svg  {\n\n  animation: edu-spin 2.95s infinite linear;\n}\n\n.spinner-122  {\n\n  border-bottom: 3px solid #F1C40F;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-122\">\n  <FaReact />\n</div>"
  },
  {
    "id": 123,
    "className": "spinner-123",
    "css": ".spinner-123  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #2C3E50;\n}\n\n.spinner-123 svg  {\n\n  animation: edu-bounce 1.79s infinite linear;\n}",
    "html": "<div className=\"spinner-123\">\n  <FaReact />\n</div>"
  },
  {
    "id": 124,
    "className": "spinner-124",
    "css": ".spinner-124  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  color: #2C3E50;\n}\n\n.spinner-124 svg  {\n\n  animation: edu-flip 2.87s infinite linear;\n}",
    "html": "<div className=\"spinner-124\">\n  <FaReact />\n</div>"
  },
  {
    "id": 125,
    "className": "spinner-125",
    "css": ".spinner-125  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 50px;\n  color: #8C33FF;\n}\n\n.spinner-125 svg  {\n\n  animation: edu-pulse 1.32s infinite linear;\n}\n\n.spinner-125  {\n\n  width: 70px;\n  height: 70px;\n  border: 2px solid #8C33FF;\n  border-radius: 50%;\n  background-color: #8C33FF10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-125\">\n  <FaReact />\n</div>"
  },
  {
    "id": 126,
    "className": "spinner-126",
    "css": ".spinner-126  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #2980B9;\n}\n\n.spinner-126 svg  {\n\n  animation: edu-flip 1.73s infinite linear;\n}\n\n.spinner-126  {\n\n  position: relative;\n  width: 52px;\n  height: 52px;\n}\n\n.spinner-126::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #2980B9;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-126\">\n  <FaReact />\n</div>"
  },
  {
    "id": 127,
    "className": "spinner-127",
    "css": ".spinner-127  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  color: #FF5733;\n}\n\n.spinner-127 svg  {\n\n  animation: edu-fade 1.06s infinite linear;\n}\n\n.spinner-127  {\n\n  border-bottom: 3px solid #FF5733;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-127\">\n  <FaReact />\n</div>"
  },
  {
    "id": 128,
    "className": "spinner-128",
    "css": ".spinner-128  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #ECF0F1;\n}\n\n.spinner-128 svg  {\n\n  animation: edu-flip 1.12s infinite linear;\n}",
    "html": "<div className=\"spinner-128\">\n  <FaReact />\n</div>"
  },
  {
    "id": 129,
    "className": "spinner-129",
    "css": ".spinner-129  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 37px;\n  color: #FF5733;\n}\n\n.spinner-129 svg  {\n\n  animation: edu-spin 1.63s infinite linear;\n}",
    "html": "<div className=\"spinner-129\">\n  <FaReact />\n</div>"
  },
  {
    "id": 130,
    "className": "spinner-130",
    "css": ".spinner-130  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 44px;\n  color: #8E44AD;\n}\n\n.spinner-130 svg  {\n\n  animation: edu-spin 1.11s infinite linear;\n}\n\n.spinner-130  {\n\n  width: 64px;\n  height: 64px;\n  border: 2px solid #8E44AD;\n  border-radius: 50%;\n  background-color: #8E44AD10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-130\">\n  <FaReact />\n</div>"
  },
  {
    "id": 131,
    "className": "spinner-131",
    "css": ".spinner-131  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 47px;\n  color: #D35400;\n}\n\n.spinner-131 svg  {\n\n  animation: edu-spin 1.86s infinite linear;\n}\n\n.spinner-131  {\n\n  position: relative;\n  width: 67px;\n  height: 67px;\n}\n\n.spinner-131::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #D35400;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-131\">\n  <FaReact />\n</div>"
  },
  {
    "id": 132,
    "className": "spinner-132",
    "css": ".spinner-132  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #3357FF;\n}\n\n.spinner-132 svg  {\n\n  animation: edu-spin 1.1s infinite linear;\n}\n\n.spinner-132  {\n\n  border-bottom: 3px solid #3357FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-132\">\n  <FaReact />\n</div>"
  },
  {
    "id": 133,
    "className": "spinner-133",
    "css": ".spinner-133  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 40px;\n  color: #2980B9;\n}\n\n.spinner-133 svg  {\n\n  animation: edu-spin-reverse 2.84s infinite linear;\n}",
    "html": "<div className=\"spinner-133\">\n  <FaReact />\n</div>"
  },
  {
    "id": 134,
    "className": "spinner-134",
    "css": ".spinner-134  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #E74C3C;\n}\n\n.spinner-134 svg  {\n\n  animation: edu-flip 1.32s infinite linear;\n}",
    "html": "<div className=\"spinner-134\">\n  <FaReact />\n</div>"
  },
  {
    "id": 135,
    "className": "spinner-135",
    "css": ".spinner-135  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #16A085;\n}\n\n.spinner-135 svg  {\n\n  animation: edu-spin-reverse 1.49s infinite linear;\n}\n\n.spinner-135  {\n\n  width: 59px;\n  height: 59px;\n  border: 2px solid #16A085;\n  border-radius: 50%;\n  background-color: #16A08510;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-135\">\n  <FaReact />\n</div>"
  },
  {
    "id": 136,
    "className": "spinner-136",
    "css": ".spinner-136  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #FF33A1;\n}\n\n.spinner-136 svg  {\n\n  animation: edu-bounce 2.97s infinite linear;\n}\n\n.spinner-136  {\n\n  position: relative;\n  width: 69px;\n  height: 69px;\n}\n\n.spinner-136::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #FF33A1;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-136\">\n  <FaReact />\n</div>"
  },
  {
    "id": 137,
    "className": "spinner-137",
    "css": ".spinner-137  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #FF5733;\n}\n\n.spinner-137 svg  {\n\n  animation: edu-fade 1.76s infinite linear;\n}\n\n.spinner-137  {\n\n  border-bottom: 3px solid #FF5733;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-137\">\n  <FaReact />\n</div>"
  },
  {
    "id": 138,
    "className": "spinner-138",
    "css": ".spinner-138  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 44px;\n  color: #3357FF;\n}\n\n.spinner-138 svg  {\n\n  animation: edu-spin 1.42s infinite linear;\n}",
    "html": "<div className=\"spinner-138\">\n  <FaReact />\n</div>"
  },
  {
    "id": 139,
    "className": "spinner-139",
    "css": ".spinner-139  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 34px;\n  color: #F5FF33;\n}\n\n.spinner-139 svg  {\n\n  animation: edu-pulse 1.43s infinite linear;\n}",
    "html": "<div className=\"spinner-139\">\n  <FaReact />\n</div>"
  },
  {
    "id": 140,
    "className": "spinner-140",
    "css": ".spinner-140  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 50px;\n  color: #D35400;\n}\n\n.spinner-140 svg  {\n\n  animation: edu-bounce 2.39s infinite linear;\n}\n\n.spinner-140  {\n\n  width: 70px;\n  height: 70px;\n  border: 2px solid #D35400;\n  border-radius: 50%;\n  background-color: #D3540010;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-140\">\n  <FaReact />\n</div>"
  },
  {
    "id": 141,
    "className": "spinner-141",
    "css": ".spinner-141  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 47px;\n  color: #33FF57;\n}\n\n.spinner-141 svg  {\n\n  animation: edu-wiggle 2.52s infinite linear;\n}\n\n.spinner-141  {\n\n  position: relative;\n  width: 67px;\n  height: 67px;\n}\n\n.spinner-141::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #33FF57;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-141\">\n  <FaReact />\n</div>"
  },
  {
    "id": 142,
    "className": "spinner-142",
    "css": ".spinner-142  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 36px;\n  color: #FF5733;\n}\n\n.spinner-142 svg  {\n\n  animation: edu-wiggle 2.91s infinite linear;\n}\n\n.spinner-142  {\n\n  border-bottom: 3px solid #FF5733;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-142\">\n  <FaReact />\n</div>"
  },
  {
    "id": 143,
    "className": "spinner-143",
    "css": ".spinner-143  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 44px;\n  color: #FF8C33;\n}\n\n.spinner-143 svg  {\n\n  animation: edu-spin 2.69s infinite linear;\n}",
    "html": "<div className=\"spinner-143\">\n  <FaReact />\n</div>"
  },
  {
    "id": 144,
    "className": "spinner-144",
    "css": ".spinner-144  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 41px;\n  color: #27AE60;\n}\n\n.spinner-144 svg  {\n\n  animation: edu-pulse 2.36s infinite linear;\n}",
    "html": "<div className=\"spinner-144\">\n  <FaReact />\n</div>"
  },
  {
    "id": 145,
    "className": "spinner-145",
    "css": ".spinner-145  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #A133FF;\n}\n\n.spinner-145 svg  {\n\n  animation: edu-wiggle 2.28s infinite linear;\n}\n\n.spinner-145  {\n\n  width: 65px;\n  height: 65px;\n  border: 2px solid #A133FF;\n  border-radius: 50%;\n  background-color: #A133FF10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-145\">\n  <FaReact />\n</div>"
  },
  {
    "id": 146,
    "className": "spinner-146",
    "css": ".spinner-146  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 37px;\n  color: #33FF8C;\n}\n\n.spinner-146 svg  {\n\n  animation: edu-wiggle 2.53s infinite linear;\n}\n\n.spinner-146  {\n\n  position: relative;\n  width: 57px;\n  height: 57px;\n}\n\n.spinner-146::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #33FF8C;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-146\">\n  <FaReact />\n</div>"
  },
  {
    "id": 147,
    "className": "spinner-147",
    "css": ".spinner-147  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 41px;\n  color: #2980B9;\n}\n\n.spinner-147 svg  {\n\n  animation: edu-spin-reverse 2.99s infinite linear;\n}\n\n.spinner-147  {\n\n  border-bottom: 3px solid #2980B9;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-147\">\n  <FaReact />\n</div>"
  },
  {
    "id": 148,
    "className": "spinner-148",
    "css": ".spinner-148  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #A133FF;\n}\n\n.spinner-148 svg  {\n\n  animation: edu-wiggle 2.48s infinite linear;\n}",
    "html": "<div className=\"spinner-148\">\n  <FaReact />\n</div>"
  },
  {
    "id": 149,
    "className": "spinner-149",
    "css": ".spinner-149  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 31px;\n  color: #F5FF33;\n}\n\n.spinner-149 svg  {\n\n  animation: edu-spin 1.01s infinite linear;\n}",
    "html": "<div className=\"spinner-149\">\n  <FaReact />\n</div>"
  },
  {
    "id": 150,
    "className": "spinner-150",
    "css": ".spinner-150  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 36px;\n  color: #2C3E50;\n}\n\n.spinner-150 svg  {\n\n  animation: edu-fade 1.53s infinite linear;\n}\n\n.spinner-150  {\n\n  width: 56px;\n  height: 56px;\n  border: 2px solid #2C3E50;\n  border-radius: 50%;\n  background-color: #2C3E5010;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-150\">\n  <FaReact />\n</div>"
  },
  {
    "id": 151,
    "className": "spinner-151",
    "css": ".spinner-151  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 41px;\n  color: #D35400;\n}\n\n.spinner-151 svg  {\n\n  animation: edu-spin-reverse 2.1s infinite linear;\n}\n\n.spinner-151  {\n\n  position: relative;\n  width: 61px;\n  height: 61px;\n}\n\n.spinner-151::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #D35400;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-151\">\n  <FaReact />\n</div>"
  },
  {
    "id": 152,
    "className": "spinner-152",
    "css": ".spinner-152  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #27AE60;\n}\n\n.spinner-152 svg  {\n\n  animation: edu-flip 1.11s infinite linear;\n}\n\n.spinner-152  {\n\n  border-bottom: 3px solid #27AE60;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-152\">\n  <FaReact />\n</div>"
  },
  {
    "id": 153,
    "className": "spinner-153",
    "css": ".spinner-153  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 35px;\n  color: #ECF0F1;\n}\n\n.spinner-153 svg  {\n\n  animation: edu-spin-reverse 2.48s infinite linear;\n}",
    "html": "<div className=\"spinner-153\">\n  <FaReact />\n</div>"
  },
  {
    "id": 154,
    "className": "spinner-154",
    "css": ".spinner-154  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  color: #D35400;\n}\n\n.spinner-154 svg  {\n\n  animation: edu-pulse 1.67s infinite linear;\n}",
    "html": "<div className=\"spinner-154\">\n  <FaReact />\n</div>"
  },
  {
    "id": 155,
    "className": "spinner-155",
    "css": ".spinner-155  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #33FF57;\n}\n\n.spinner-155 svg  {\n\n  animation: edu-fade 1.68s infinite linear;\n}\n\n.spinner-155  {\n\n  width: 69px;\n  height: 69px;\n  border: 2px solid #33FF57;\n  border-radius: 50%;\n  background-color: #33FF5710;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-155\">\n  <FaReact />\n</div>"
  },
  {
    "id": 156,
    "className": "spinner-156",
    "css": ".spinner-156  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 50px;\n  color: #16A085;\n}\n\n.spinner-156 svg  {\n\n  animation: edu-flip 2.15s infinite linear;\n}\n\n.spinner-156  {\n\n  position: relative;\n  width: 70px;\n  height: 70px;\n}\n\n.spinner-156::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #16A085;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-156\">\n  <FaReact />\n</div>"
  },
  {
    "id": 157,
    "className": "spinner-157",
    "css": ".spinner-157  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 50px;\n  color: #3357FF;\n}\n\n.spinner-157 svg  {\n\n  animation: edu-spin-reverse 1.8s infinite linear;\n}\n\n.spinner-157  {\n\n  border-bottom: 3px solid #3357FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-157\">\n  <FaReact />\n</div>"
  },
  {
    "id": 158,
    "className": "spinner-158",
    "css": ".spinner-158  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 44px;\n  color: #16A085;\n}\n\n.spinner-158 svg  {\n\n  animation: edu-bounce 1.21s infinite linear;\n}",
    "html": "<div className=\"spinner-158\">\n  <FaReact />\n</div>"
  },
  {
    "id": 159,
    "className": "spinner-159",
    "css": ".spinner-159  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #FF33A1;\n}\n\n.spinner-159 svg  {\n\n  animation: edu-spin 2.7s infinite linear;\n}",
    "html": "<div className=\"spinner-159\">\n  <FaReact />\n</div>"
  },
  {
    "id": 160,
    "className": "spinner-160",
    "css": ".spinner-160  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 35px;\n  color: #2980B9;\n}\n\n.spinner-160 svg  {\n\n  animation: edu-spin-reverse 1.46s infinite linear;\n}\n\n.spinner-160  {\n\n  width: 55px;\n  height: 55px;\n  border: 2px solid #2980B9;\n  border-radius: 50%;\n  background-color: #2980B910;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-160\">\n  <FaReact />\n</div>"
  },
  {
    "id": 161,
    "className": "spinner-161",
    "css": ".spinner-161  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 31px;\n  color: #FF8C33;\n}\n\n.spinner-161 svg  {\n\n  animation: edu-spin-reverse 1.78s infinite linear;\n}\n\n.spinner-161  {\n\n  position: relative;\n  width: 51px;\n  height: 51px;\n}\n\n.spinner-161::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #FF8C33;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-161\">\n  <FaReact />\n</div>"
  },
  {
    "id": 162,
    "className": "spinner-162",
    "css": ".spinner-162  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 42px;\n  color: #3357FF;\n}\n\n.spinner-162 svg  {\n\n  animation: edu-flip 1.96s infinite linear;\n}\n\n.spinner-162  {\n\n  border-bottom: 3px solid #3357FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-162\">\n  <FaReact />\n</div>"
  },
  {
    "id": 163,
    "className": "spinner-163",
    "css": ".spinner-163  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 40px;\n  color: #FF8C33;\n}\n\n.spinner-163 svg  {\n\n  animation: edu-pulse 1.76s infinite linear;\n}",
    "html": "<div className=\"spinner-163\">\n  <FaReact />\n</div>"
  },
  {
    "id": 164,
    "className": "spinner-164",
    "css": ".spinner-164  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #A133FF;\n}\n\n.spinner-164 svg  {\n\n  animation: edu-spin 2.26s infinite linear;\n}",
    "html": "<div className=\"spinner-164\">\n  <FaReact />\n</div>"
  },
  {
    "id": 165,
    "className": "spinner-165",
    "css": ".spinner-165  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #F1C40F;\n}\n\n.spinner-165 svg  {\n\n  animation: edu-bounce 2.61s infinite linear;\n}\n\n.spinner-165  {\n\n  width: 63px;\n  height: 63px;\n  border: 2px solid #F1C40F;\n  border-radius: 50%;\n  background-color: #F1C40F10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-165\">\n  <FaReact />\n</div>"
  },
  {
    "id": 166,
    "className": "spinner-166",
    "css": ".spinner-166  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  color: #2980B9;\n}\n\n.spinner-166 svg  {\n\n  animation: edu-fade 1.83s infinite linear;\n}\n\n.spinner-166  {\n\n  position: relative;\n  width: 50px;\n  height: 50px;\n}\n\n.spinner-166::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #2980B9;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-166\">\n  <FaReact />\n</div>"
  },
  {
    "id": 167,
    "className": "spinner-167",
    "css": ".spinner-167  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #FF5733;\n}\n\n.spinner-167 svg  {\n\n  animation: edu-spin 2.55s infinite linear;\n}\n\n.spinner-167  {\n\n  border-bottom: 3px solid #FF5733;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-167\">\n  <FaReact />\n</div>"
  },
  {
    "id": 168,
    "className": "spinner-168",
    "css": ".spinner-168  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 31px;\n  color: #F1C40F;\n}\n\n.spinner-168 svg  {\n\n  animation: edu-pulse 2.98s infinite linear;\n}",
    "html": "<div className=\"spinner-168\">\n  <FaReact />\n</div>"
  },
  {
    "id": 169,
    "className": "spinner-169",
    "css": ".spinner-169  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #8C33FF;\n}\n\n.spinner-169 svg  {\n\n  animation: edu-bounce 1.92s infinite linear;\n}",
    "html": "<div className=\"spinner-169\">\n  <FaReact />\n</div>"
  },
  {
    "id": 170,
    "className": "spinner-170",
    "css": ".spinner-170  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #3498DB;\n}\n\n.spinner-170 svg  {\n\n  animation: edu-spin-reverse 2.2s infinite linear;\n}\n\n.spinner-170  {\n\n  width: 68px;\n  height: 68px;\n  border: 2px solid #3498DB;\n  border-radius: 50%;\n  background-color: #3498DB10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-170\">\n  <FaReact />\n</div>"
  },
  {
    "id": 171,
    "className": "spinner-171",
    "css": ".spinner-171  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #ECF0F1;\n}\n\n.spinner-171 svg  {\n\n  animation: edu-spin 1.81s infinite linear;\n}\n\n.spinner-171  {\n\n  position: relative;\n  width: 53px;\n  height: 53px;\n}\n\n.spinner-171::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #ECF0F1;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-171\">\n  <FaReact />\n</div>"
  },
  {
    "id": 172,
    "className": "spinner-172",
    "css": ".spinner-172  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 41px;\n  color: #8C33FF;\n}\n\n.spinner-172 svg  {\n\n  animation: edu-fade 2.7s infinite linear;\n}\n\n.spinner-172  {\n\n  border-bottom: 3px solid #8C33FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-172\">\n  <FaReact />\n</div>"
  },
  {
    "id": 173,
    "className": "spinner-173",
    "css": ".spinner-173  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  color: #2980B9;\n}\n\n.spinner-173 svg  {\n\n  animation: edu-wiggle 1.6s infinite linear;\n}",
    "html": "<div className=\"spinner-173\">\n  <FaReact />\n</div>"
  },
  {
    "id": 174,
    "className": "spinner-174",
    "css": ".spinner-174  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 42px;\n  color: #FF8C33;\n}\n\n.spinner-174 svg  {\n\n  animation: edu-flip 1.24s infinite linear;\n}",
    "html": "<div className=\"spinner-174\">\n  <FaReact />\n</div>"
  },
  {
    "id": 175,
    "className": "spinner-175",
    "css": ".spinner-175  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  color: #16A085;\n}\n\n.spinner-175 svg  {\n\n  animation: edu-fade 2.76s infinite linear;\n}\n\n.spinner-175  {\n\n  width: 66px;\n  height: 66px;\n  border: 2px solid #16A085;\n  border-radius: 50%;\n  background-color: #16A08510;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-175\">\n  <FaReact />\n</div>"
  },
  {
    "id": 176,
    "className": "spinner-176",
    "css": ".spinner-176  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 31px;\n  color: #F1C40F;\n}\n\n.spinner-176 svg  {\n\n  animation: edu-spin 1.74s infinite linear;\n}\n\n.spinner-176  {\n\n  position: relative;\n  width: 51px;\n  height: 51px;\n}\n\n.spinner-176::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #F1C40F;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-176\">\n  <FaReact />\n</div>"
  },
  {
    "id": 177,
    "className": "spinner-177",
    "css": ".spinner-177  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 42px;\n  color: #33FFF5;\n}\n\n.spinner-177 svg  {\n\n  animation: edu-bounce 2.07s infinite linear;\n}\n\n.spinner-177  {\n\n  border-bottom: 3px solid #33FFF5;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-177\">\n  <FaReact />\n</div>"
  },
  {
    "id": 178,
    "className": "spinner-178",
    "css": ".spinner-178  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 37px;\n  color: #8E44AD;\n}\n\n.spinner-178 svg  {\n\n  animation: edu-spin-reverse 1.56s infinite linear;\n}",
    "html": "<div className=\"spinner-178\">\n  <FaReact />\n</div>"
  },
  {
    "id": 179,
    "className": "spinner-179",
    "css": ".spinner-179  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 35px;\n  color: #16A085;\n}\n\n.spinner-179 svg  {\n\n  animation: edu-spin-reverse 2.28s infinite linear;\n}",
    "html": "<div className=\"spinner-179\">\n  <FaReact />\n</div>"
  },
  {
    "id": 180,
    "className": "spinner-180",
    "css": ".spinner-180  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 37px;\n  color: #8C33FF;\n}\n\n.spinner-180 svg  {\n\n  animation: edu-flip 1.66s infinite linear;\n}\n\n.spinner-180  {\n\n  width: 57px;\n  height: 57px;\n  border: 2px solid #8C33FF;\n  border-radius: 50%;\n  background-color: #8C33FF10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-180\">\n  <FaReact />\n</div>"
  },
  {
    "id": 181,
    "className": "spinner-181",
    "css": ".spinner-181  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #33FF57;\n}\n\n.spinner-181 svg  {\n\n  animation: edu-pulse 2.15s infinite linear;\n}\n\n.spinner-181  {\n\n  position: relative;\n  width: 68px;\n  height: 68px;\n}\n\n.spinner-181::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #33FF57;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-181\">\n  <FaReact />\n</div>"
  },
  {
    "id": 182,
    "className": "spinner-182",
    "css": ".spinner-182  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 42px;\n  color: #FF8C33;\n}\n\n.spinner-182 svg  {\n\n  animation: edu-spin 2.49s infinite linear;\n}\n\n.spinner-182  {\n\n  border-bottom: 3px solid #FF8C33;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-182\">\n  <FaReact />\n</div>"
  },
  {
    "id": 183,
    "className": "spinner-183",
    "css": ".spinner-183  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 47px;\n  color: #2980B9;\n}\n\n.spinner-183 svg  {\n\n  animation: edu-spin-reverse 2.95s infinite linear;\n}",
    "html": "<div className=\"spinner-183\">\n  <FaReact />\n</div>"
  },
  {
    "id": 184,
    "className": "spinner-184",
    "css": ".spinner-184  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #27AE60;\n}\n\n.spinner-184 svg  {\n\n  animation: edu-wiggle 1.14s infinite linear;\n}",
    "html": "<div className=\"spinner-184\">\n  <FaReact />\n</div>"
  },
  {
    "id": 185,
    "className": "spinner-185",
    "css": ".spinner-185  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 39px;\n  color: #D35400;\n}\n\n.spinner-185 svg  {\n\n  animation: edu-spin 2.11s infinite linear;\n}\n\n.spinner-185  {\n\n  width: 59px;\n  height: 59px;\n  border: 2px solid #D35400;\n  border-radius: 50%;\n  background-color: #D3540010;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-185\">\n  <FaReact />\n</div>"
  },
  {
    "id": 186,
    "className": "spinner-186",
    "css": ".spinner-186  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  color: #27AE60;\n}\n\n.spinner-186 svg  {\n\n  animation: edu-spin 1.09s infinite linear;\n}\n\n.spinner-186  {\n\n  position: relative;\n  width: 66px;\n  height: 66px;\n}\n\n.spinner-186::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #27AE60;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-186\">\n  <FaReact />\n</div>"
  },
  {
    "id": 187,
    "className": "spinner-187",
    "css": ".spinner-187  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 43px;\n  color: #F1C40F;\n}\n\n.spinner-187 svg  {\n\n  animation: edu-spin 1.38s infinite linear;\n}\n\n.spinner-187  {\n\n  border-bottom: 3px solid #F1C40F;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-187\">\n  <FaReact />\n</div>"
  },
  {
    "id": 188,
    "className": "spinner-188",
    "css": ".spinner-188  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #2C3E50;\n}\n\n.spinner-188 svg  {\n\n  animation: edu-wiggle 1.89s infinite linear;\n}",
    "html": "<div className=\"spinner-188\">\n  <FaReact />\n</div>"
  },
  {
    "id": 189,
    "className": "spinner-189",
    "css": ".spinner-189  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 34px;\n  color: #3357FF;\n}\n\n.spinner-189 svg  {\n\n  animation: edu-bounce 2.68s infinite linear;\n}",
    "html": "<div className=\"spinner-189\">\n  <FaReact />\n</div>"
  },
  {
    "id": 190,
    "className": "spinner-190",
    "css": ".spinner-190  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  color: #8C33FF;\n}\n\n.spinner-190 svg  {\n\n  animation: edu-spin 1.86s infinite linear;\n}\n\n.spinner-190  {\n\n  width: 50px;\n  height: 50px;\n  border: 2px solid #8C33FF;\n  border-radius: 50%;\n  background-color: #8C33FF10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-190\">\n  <FaReact />\n</div>"
  },
  {
    "id": 191,
    "className": "spinner-191",
    "css": ".spinner-191  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 33px;\n  color: #F5FF33;\n}\n\n.spinner-191 svg  {\n\n  animation: edu-spin-reverse 2.89s infinite linear;\n}\n\n.spinner-191  {\n\n  position: relative;\n  width: 53px;\n  height: 53px;\n}\n\n.spinner-191::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #F5FF33;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-191\">\n  <FaReact />\n</div>"
  },
  {
    "id": 192,
    "className": "spinner-192",
    "css": ".spinner-192  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 48px;\n  color: #E74C3C;\n}\n\n.spinner-192 svg  {\n\n  animation: edu-spin 1.11s infinite linear;\n}\n\n.spinner-192  {\n\n  border-bottom: 3px solid #E74C3C;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-192\">\n  <FaReact />\n</div>"
  },
  {
    "id": 193,
    "className": "spinner-193",
    "css": ".spinner-193  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 35px;\n  color: #33FF57;\n}\n\n.spinner-193 svg  {\n\n  animation: edu-fade 2.88s infinite linear;\n}",
    "html": "<div className=\"spinner-193\">\n  <FaReact />\n</div>"
  },
  {
    "id": 194,
    "className": "spinner-194",
    "css": ".spinner-194  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 31px;\n  color: #27AE60;\n}\n\n.spinner-194 svg  {\n\n  animation: edu-fade 2.65s infinite linear;\n}",
    "html": "<div className=\"spinner-194\">\n  <FaReact />\n</div>"
  },
  {
    "id": 195,
    "className": "spinner-195",
    "css": ".spinner-195  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #F5FF33;\n}\n\n.spinner-195 svg  {\n\n  animation: edu-spin-reverse 2.72s infinite linear;\n}\n\n.spinner-195  {\n\n  width: 69px;\n  height: 69px;\n  border: 2px solid #F5FF33;\n  border-radius: 50%;\n  background-color: #F5FF3310;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-195\">\n  <FaReact />\n</div>"
  },
  {
    "id": 196,
    "className": "spinner-196",
    "css": ".spinner-196  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 31px;\n  color: #3498DB;\n}\n\n.spinner-196 svg  {\n\n  animation: edu-spin 2.0s infinite linear;\n}\n\n.spinner-196  {\n\n  position: relative;\n  width: 51px;\n  height: 51px;\n}\n\n.spinner-196::after  {\n\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #3498DB;\n  border-radius: 50%;\n  animation: edu-spin 4s infinite linear;\n}",
    "html": "<div className=\"spinner-196\">\n  <FaReact />\n</div>"
  },
  {
    "id": 197,
    "className": "spinner-197",
    "css": ".spinner-197  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  color: #3357FF;\n}\n\n.spinner-197 svg  {\n\n  animation: edu-bounce 1.66s infinite linear;\n}\n\n.spinner-197  {\n\n  border-bottom: 3px solid #3357FF;\n  border-radius: 50%;\n  padding: 10px;\n}",
    "html": "<div className=\"spinner-197\">\n  <FaReact />\n</div>"
  },
  {
    "id": 198,
    "className": "spinner-198",
    "css": ".spinner-198  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 42px;\n  color: #FF33A1;\n}\n\n.spinner-198 svg  {\n\n  animation: edu-fade 1.2s infinite linear;\n}",
    "html": "<div className=\"spinner-198\">\n  <FaReact />\n</div>"
  },
  {
    "id": 199,
    "className": "spinner-199",
    "css": ".spinner-199  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 49px;\n  color: #3357FF;\n}\n\n.spinner-199 svg  {\n\n  animation: edu-bounce 2.55s infinite linear;\n}",
    "html": "<div className=\"spinner-199\">\n  <FaReact />\n</div>"
  },
  {
    "id": 200,
    "className": "spinner-200",
    "css": ".spinner-200  {\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 38px;\n  color: #E74C3C;\n}\n\n.spinner-200 svg  {\n\n  animation: edu-pulse 1.75s infinite linear;\n}\n\n.spinner-200  {\n\n  width: 58px;\n  height: 58px;\n  border: 2px solid #E74C3C;\n  border-radius: 50%;\n  background-color: #E74C3C10;\n  /* Transparent variation */\n}",
    "html": "<div className=\"spinner-200\">\n  <FaReact />\n</div>"
  }
];
